import Framework from 'framework';
import constants from 'lib/constants';
import { proxyToAlertNotificationStore } from './proxyToEnterpriseFramework';

const AlertNotificationStore = {
	name: 'AlertNotificationStore',
	listen: proxyToAlertNotificationStore('listen'),
	createSuccessNotification: (message, defer, dismissible, id, disableScroll) => {
		window.ef.alertNotificationStore.open({ type: 'alert-success', message, defer, dismissible, id, disableScroll });
	},
	createInfoNotification: (message, defer, dismissible, id, disableScroll) => {
		window.ef.alertNotificationStore.open({ type: 'alert-info', message, defer, dismissible, id, disableScroll });
	},
	createWarningNotification: (message, defer, dismissible, id, disableScroll) => {
		window.ef.alertNotificationStore.open({ type: 'alert-warning', message, defer, dismissible, id, disableScroll });
	},
	createDangerNotification: (message, defer, dismissible, id, disableScroll) => {
		window.ef.alertNotificationStore.open({ type: 'alert-danger', message, defer, dismissible, id, disableScroll });
	},
	closeNotification: (id) => {
		window.ef.alertNotificationStore.close({ id: id || constants.defaultAlertNotificationId });
	}
};

Framework.registerStore(AlertNotificationStore.name, AlertNotificationStore);

export default AlertNotificationStore;
